import {
  type ConferenceFilter,
  rdbV1FiltersConferencesList,
  type SiteResponse,
  v1SitesList,
} from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import type { AxiosError } from 'axios';
import { SubscribeLayout } from 'components/Layouts/SubscribeLayout';
import { SelectTeam } from 'components/Subscription/SelectTeam';
import type { GetServerSideProps } from 'next';

interface IPlansProps extends IGenericPageProps {
  conferences?: ConferenceFilter[] | null;
  sites?: SiteResponse[] | null;
}

const NetworkJoin = ({ ...props }: IPlansProps) => {
  const canonical = `https://www.on3.com/join/`;
  const title = 'Subscribe a team to subscribe to | On3';

  return (
    <SubscribeLayout {...props} canonical={canonical} title={title}>
      <SelectTeam conferences={props.conferences} sites={props.sites} />
    </SubscribeLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  try {
    const params = {
      year: siteData?.defaultYears?.footballSeasonYear,
      sportKey: 1,
    };
    const [conferences, sites] = await Promise.allSettled([
      rdbV1FiltersConferencesList(proxyApi, params),
      v1SitesList(proxyApi, {}),
    ]);

    return {
      props: {
        pageType: 'user',
        siteData,
        userData: userData || {},
        conferences: getFulfilledValue(conferences),
        sites: getFulfilledValue(sites),
      },
    };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.log(err.message);

    return { props: {} };
  }
};

export default withValidUrl(NetworkJoin);
